import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 業務選擇 - 提交選擇的業務項目
 */
const BusinessSelectionPostBack = [
    'POST',
    RouteUrlList.API_BusinessSelectionPostBack.path,
    {},
    200,
    {
        status: true,
        title: '儲存成功',
        message: '已成功儲存您選擇的補件項目',
        errorCode: ''
    }
];

export default BusinessSelectionPostBack;
